export enum ConsentCode {
  INFO_OBLIGATION_WITH_PROFILING = "INFO_OBLIGATION_WITH_PROFILING",
  PZU_DATA_SHARING_MRKT = "PZU_DATA_SHARING_MRKT"
}
